
import fondito from "../../../assets/logo_login.jpeg"
import { loadingOverlay } from "vuetify-more-component";

export default {

  components: { loadingOverlay },
  data(){
    return{
      tipoRegimen: [],
      fondito,
      loading_regimenes: false,
    };
  },

  async created() {
    console.log("/mantenimientos");
    await this.getRegimenListado();
  },

  methods: {

    async getRegimenListado() {
      try {
        this.loading_regimenes = true;
        let r = await this.$store.state.services.administradorService.getRegimenListado();
        this.tipoRegimen = r.data.data;
        this.tipoRegimen.push({id:-1, descripcion:"Generales"})
        this.loading_regimenes = false
      } catch (error) {
        console.log(error);
        this.loading_regimenes = false;
        this.$toast.error("No es posible obtener los tipos de regímen")
      }
    },

    elegir_tipo_regimen(item){
      console.log(item);
      if(item.id == 1){
        this.$router.push("/man_pc")
      }else if(item.id == 2){
        this.$router.push("/man_ros");
      }else if(item.id == 4){
        this.$router.push("/mantenimiento/limites");
      }else if(item.id == -1){
        this.$router.push("/man_gen");
      }
    },

  }
}